const Configuracion = 
  {
    proyecto: "infornavitgnpgmm",
    aplicacion:"INFONAVIT-GNP-GMM",
    version: "1.2.1",
    fechamodificacion:'09-01-2026',
    derechos:"POWER BY © SINESTRY 2025",
    basedatos:"siniestrosapdb",
    mensajesplash:"",
    author:"Ing.Juan Carlos Arreola Lopez",
    urlapi://"http://localhost:4000",
      'https://sinestrydev-552789706120.us-central1.run.app',
  };
export default Configuracion;
